import React from 'react';

import { useImportSummaryContent } from './useImportSummaryContent';

export const withImportSummaryContent = (WrappedComponent) => {
  const HOC = (props) => {
    const getImportSummaryContent = useImportSummaryContent();
    return (
      <WrappedComponent
        getImportSummaryContent={getImportSummaryContent}
        {...props}
      />
    );
  };
  return HOC;
};
